<template>
    <div class="monitor-introduce">
        <!--     banner   -->
        <div class="banner">
            <div class="banner_container">
                <div class="banner_msg">
                    <h3 class="english_title"><span class="span-line"></span>COPYRIGHT</h3>
                    <h2 class="chinese_title">版权监测 快速高效</h2>
                    <div class="text_group">
<!--                        <p>网站、微信均可监测</p>-->
<!--                        <p>文字、图片均可监测</p>-->
<!--                        <p style="width: 660px;font-size: 20px;">图片、音乐、文字类型作品针对微信公众平台、电商网站、搜索引擎、图片、图库素材进行实时监测</p>-->
                        <p style="width: 660px;font-size: 20px;">通过技术手段在网上监测有哪些侵权方盗版了您的作品，并把监测到的结果汇总给您。</p>
                    </div>
                    <div class="text_group">
                        <p>高准确度、操作简便，实时反馈监测结果</p>
                    </div>
                    <router-link to="/monitor" class="monitor_btn">去监测</router-link>
                </div>
                <!-- <div class="banner_img">
                    <img src="./images/banner.png" alt="">
                </div> -->
            </div>
        </div>

        <!--    监测数据介绍    -->
        <div class="bg_box">
            <div class="position_box number_introduce">
                <div class="number_introduce_bg">
                    <img src="./images/number_introduce_bg.png" alt="">
                </div>
                <ul class="number_introduce_text">
                    <li class="number_introduce_text_item">
                        <img class="introduce_icon" src="./images/introduce_icon1.png" alt="">
                        <div class="introduce_text_group">
                            <p>监测网站1850+</p>
                            <p>覆盖图片190亿+</p>
                        </div>
                    </li>
                    <li class="number_introduce_text_item">
                        <img class="introduce_icon" src="./images/introduce_icon2.png" alt="">
                        <div class="introduce_text_group">
                            <p>监测微信公众号200万+</p>
                            <p>覆盖图文110亿+</p>
                        </div>
                    </li>
                    <li class="number_introduce_text_item">
                        <img class="introduce_icon" src="./images/introduce_icon3.png" alt="">
                        <div class="introduce_text_group">
                            <p>日对比图文1:100亿</p>
                        </div>
                    </li>

                </ul>
            </div>
        </div>

        <!--    监测功能简介    -->
        <div class="bg_box">
            <div class="position_box main_details">
                <div class="text_box">
                    <ul class="details_text_group">
                        <li class="details_text_item">
                            <div class="details_icon">
                                <img src="./images/introduce_icon4.png" alt="">
                            </div>
                            <h3 class="details_title">先进的分析算法</h3>
                            <div class="details_text">
                                <p>自主研发的图像算法，</p>
                                <p>能在图片伸缩、加文字logo、几何变形</p>
                                <p>的情况下快速匹配原图</p>
                            </div>
                        </li>
                        <li class="details_text_item">
                            <div class="details_icon">
                                <img src="./images/introduce_icon5.png" alt="">
                            </div>
                            <h3 class="details_title">分析式SOC数据库</h3>
                            <div class="details_text">
                                <p>自主研发的低成本数据库解决方案，</p>
                                <p>拥有3150多台机器，支持平行扩展</p>
                            </div>
                        </li>
                        <li class="details_text_item">
                            <div class="details_icon">
                                <img src="./images/introduce_icon6.png" alt="">
                            </div>
                            <h3 class="details_title">自主设计的SOC云</h3>
                            <div class="details_text">
                                <p>国内做图像分布式的，</p>
                                <p>可运行在SOC(System on Chip)</p>
                                <p>片上系统的数据库公司</p>
                            </div>
                        </li>
                        <li class="details_text_item">
                            <div class="details_icon">
                                <img src="./images/introduce_icon7.png" alt="">
                            </div>
                            <h3 class="details_title">人工智能</h3>
                            <div class="details_text">
                                <p>基于深度学习的智能内容监测，</p>
                                <p>准确识别图片内容，从外观和清晰等</p>
                                <p>多维度对图像进行筛选，快速、精准</p>
                            </div>
                        </li>


                    </ul>
                </div>
                <div class="photo_box">
                    <img src="./images/componter_introduce_bg.png" alt="">
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    export default {
        metaInfo: {
            title: '版权监测介绍|时尚知识产权保护平台',
            meta: [{                 // set meta
                name: 'keyWords',
                content: ''
            },{
                name: 'Description',
                content: ''
            }]
        },
        name: "monitorIntroduce"
    }
</script>

<style scoped>
    .monitor-introduce .banner {
        display: block;
        width: 100%;
        height: 460px;
        background:#121210;
        color: #fff;
        box-sizing: border-box;
    }

    .banner .banner_container {
        width: 1334px;
        height: 460px;
        margin: 0 auto;
        overflow: hidden;
        background: url(./images/bg-jc.png) no-repeat;
        background-size: 100% 100%;
        background-position: center;
    }

    .banner .banner_msg {
        padding-top: 58px;
        float: left;
    }

    .banner_msg .english_title {
        font-size: 20px;
        font-weight: 300;
        line-height: 28px;
        letter-spacing: 2px;
    }
    .span-line{
        display: inline-block;
        width:70px;
        height:1px;
        background: #fff;
        vertical-align: middle;
        margin-right: 15px;
    }
    .banner_msg .chinese_title {
        font-size: 50px;
        font-weight: bold;
        line-height: 70px;
        letter-spacing: 6px;
        padding-top: 10px;
    }

    .text_group {
        padding-top: 25px;
        font-size: 25px;
        line-height: 34px;
        letter-spacing: 10px;
    }

    .banner .monitor_btn {
        margin-top: 40px;
        width: 138px;
        height: 40px;
        text-align: center;
        line-height: 40px;
        background:rgba(255,255,255,1);
        color: #191919;
        font-size: 14px;
        font-weight: 400;
        cursor: pointer;
        display: inline-block;
    }

    .banner .banner_img {
        margin: 13px 0 0 81px;
        width: 523px;
        height: 447px;
        float: left;
    }

    .banner_img img {
        display: block;
        width: 100%;
        height: 100%;
    }

    .main {
        margin-top: 50px;
        background: #fff;
    }

    .number_introduce .number_introduce_bg {
        width: 453px;
        height: 349px;
        position: relative;
    }

    .number_introduce_bg img {
        display: block;
        width: 100%;
        height: 100%;
    }

    .bg_box {
        background: #fff;
        margin-top:128px;
    }

    .position_box {
        width: 1334px;
        position: relative;
        margin: 0 auto 0;
        background: #fff;
    }

    .number_introduce .number_introduce_bg:after {
        content: '';
        position: absolute;
        right: -25px;
        top: 324px;
        width: 50px;
        height: 50px;
        background: url(./images/right_arrow.png) no-repeat left center;
        background-size: 100% 100%;
        z-index: 2;
    }

    .number_introduce .number_introduce_text {
        position: absolute;
        left: 548px;
        top: 126px;
    }

    .number_introduce_text .number_introduce_text_item {
        display: inline-block;
        margin-right: 100px;
        color: #333333;
        font-size: 16px;
        vertical-align: top;
    }

    .number_introduce_text .number_introduce_text_item:last-child {
        margin-right: 0;
    }

    .number_introduce_text_item .introduce_icon {
        width: 24px;
        height: 28px;
        display: block;
    }

    .number_introduce_text_item .introduce_text_group {
        padding-top: 20px;
    }

    .main_details{
        margin-bottom: 52px;
    }

    .main_details .text_box {
        padding-top: 55px;
        width: 930px;
        background: #fff;
        position: relative;
        font-size: 36px;
    }

    .text_box .details_text_group {
        margin-left: 59px;
        width: 616px;
        font-size: 0;
    }

    .details_text_group .details_text_item {
        display: inline-block;
        color: #666;
        width: 50%;
        margin-bottom: 50px;
        vertical-align: top;
    }

    .details_text_item .details_icon {
        width: 28px;
        height: 27px;
    }

    .details_icon img {
        display: block;
        width: 100%;
        height: 100%;
    }

    .details_text_item .details_title {
        font-size: 20px;
        padding-top: 20px;
    }

    .details_text_item .details_text {
        font-size: 14px;
        color: #666;
        padding-top: 20px;
        line-height: 25px;
    }

    .main_details .photo_box {
        width: 441px;
        height: 349px;
        position: absolute;
        right:0px;
        top: 73px;
    }

    .photo_box img {
        display: block;
        width: 100%;
        height: 100%;
    }

    .photo_box:after {
        content: '';
        position: absolute;
        left: -25px;
        top: 324px;
        width: 50px;
        height: 50px;
        background: url(./images/left_arrow.png) no-repeat left center;
        background-size: 100% 100%;
        z-index: 2;
    }
</style>